var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLenght(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.9824 102.608L15.8899 83.515L88.0174 11.39L107.11 30.4825L34.9824 102.608ZM24.3749 83.515L34.9824 94.1225L98.6224 30.4825L88.0149 19.875L24.3749 83.515Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81.6523 21.9967L77.4097 26.2393L83.7736 32.6033L88.0163 28.3606L81.6523 21.9967Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1666 30.483L68.9239 34.7257L75.2879 41.0896L79.5305 36.847L73.1666 30.483Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6816 38.9676L60.4389 43.2103L66.8029 49.5742L71.0455 45.3316L64.6816 38.9676Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1966 47.4547L51.9539 51.6974L58.3179 58.0613L62.5605 53.8187L56.1966 47.4547Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7116 55.9368L43.4689 60.1795L49.8329 66.5434L54.0755 62.3008L47.7116 55.9368Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2248 64.4257L34.9822 68.6684L41.3461 75.0323L45.5888 70.7897L39.2248 64.4257Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7398 72.9103L26.4972 77.1529L32.8611 83.5169L37.1038 79.2743L30.7398 72.9103Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLenght);
export default __webpack_public_path__ + "static/media/Lenght.e6792a30.svg";
export { ForwardRef as ReactComponent };